import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {push} from 'connected-react-router';

import loginImage from 'assets/images/login.png';

import {ROUTE} from 'containers/App/constants';
import {selectApp} from 'store/selectors';

import {Background} from 'components';

import Form from './Form';
import {login} from 'auth/api';
import LoginDisclaimer from './LoginDisclaimer';
import {saveTokens} from 'auth/utils';
import {ApiError} from 'api/error';

function Login() {
  // Local state

  const [serverError, setServerError] = useState<string>();

  // Redux stuff

  const dispatch = useDispatch();
  const {user} = useSelector(selectApp);

  // Effects

  useEffect(() => {
    if (user && user.email) {
      dispatch(push(ROUTE.Dashboard));
    }
  }, [dispatch, user]);

  // Event handlers

  const onSignIn = async (email: string, password: string) => {
    try {
      // Request login and save tokens.
      const loginData = await login({email, password});
      saveTokens(loginData);

      // Redirect to dashboard on successful login.
      dispatch(push(ROUTE.Dashboard));
    } catch (e) {
      // Save server error to local state if failed the request.
      const err = e as ApiError;
      setServerError(err.message);
    }
  };

  return (
    <Background>
      <div className="pt-24 px-2 lg:pt-0 lg:w-640 mx-auto flex flex-col justify-center">
        <img src={loginImage} className="mx-auto -mb-16" alt="Login" />
        <Form onSignIn={onSignIn} serverError={serverError} />
        <LoginDisclaimer />
      </div>
    </Background>
  );
}

export default Login;
